import { Flex } from "@chakra-ui/react";
import { NextSeo } from "next-seo";
import Link from "next/link";

import Hero from "components/Hero";
import NeumorphicButton from "components/UI/NeumorphicButton";
import HomeLayout from "components/layouts/HomeLayout";
import paths from "paths";
import theme from "theme";
import type { Page } from "types/page";

// https://www.jimraptis.com/blog/build-a-landing-page-with-chakra-ui-part-1
const Home: Page = () => (
  <>
    <NextSeo title="The Rock Program" description="Home page" />
    <Flex
      m={theme.spacing.sm}
      alignSelf="center"
      direction="column"
      justifyContent="space-between"
      alignItems="center"
      height="full"
      width={["xs", "sm", "md"]}
    >
      <Hero />

      <Flex
        align="center"
        direction="column"
        alignItems="stretch"
        gridGap={theme.spacing.xs}
        width="full"
      >
        <Link href={paths.auth.register} passHref>
          <NeumorphicButton height="60px" testId="btn-signup">
            Sign Up
          </NeumorphicButton>
        </Link>
        <Link href={paths.auth.login} passHref>
          <NeumorphicButton
            variant="secondary"
            height="60px"
            testId="btn-signin"
          >
            Sign In
          </NeumorphicButton>
        </Link>
      </Flex>
    </Flex>
  </>
);

Home.Layout = HomeLayout;

export default Home;
